import { render, staticRenderFns } from "./ModalDownloadIncome.vue?vue&type=template&id=06e6acb2"
import script from "./ModalDownloadIncome.vue?vue&type=script&lang=js"
export * from "./ModalDownloadIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports